import { SvgIcon } from '@mui/material';
import { SMPalette } from '@nx-smartmonkey/ui';

interface GoalRoutesTrackingProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function GoalRoutesTracking({ color = SMPalette.grey1, style = {} }: GoalRoutesTrackingProps) {
  return (
    <SvgIcon viewBox="0 0 22.34 23.25" style={{ width: `24px`, ...style }}>
      <g>
        <path
          fill={color}
          d="m11.45,3.74c-1.83-.15-3.44,1.21-3.59,3.04-.15,1.83,1.21,3.44,3.04,3.59.09.01.18.01.27.01,1.73,0,3.18-1.33,3.32-3.05.15-1.83-1.21-3.44-3.04-3.59Zm-.3,5.1c-.98,0-1.78-.8-1.77-1.79s.8-1.78,1.79-1.77c.05,0,.1,0,.15,0,.92.08,1.63.85,1.62,1.78,0,.98-.8,1.78-1.79,1.77Z"
        />
        <path
          fill={color}
          d="m11.17.13C5.44.05.72,4.64.64,10.37c.05,4.78,3.38,8.89,8.04,9.94l1.81,2.46c.28.38.82.45,1.2.17.06-.05.12-.11.17-.17l1.81-2.46c4.66-1.05,7.99-5.16,8.04-9.94C21.62,4.64,16.91.05,11.17.13Zm3.46,18.21c-.48.2-.97.37-1.49.51-.42.07-.8.3-1.04.65l-.93,1.32-.93-1.32c-.25-.35-.62-.58-1.04-.65-.76-.21-1.46-.49-2.12-.83-.66-.34-1.26-.77-1.83-1.25l.26-.45c1.17-2.04,3.27-3.26,5.62-3.26h.02c2.36,0,4.47,1.24,5.63,3.3l.27.47c-.73.61-1.53,1.14-2.41,1.5Zm3.62-2.68l-.06-.1c-1.45-2.57-4.08-4.12-7.04-4.13-2.97-.02-5.6,1.51-7.07,4.08l-.05.08c-1.22-1.5-1.89-3.37-1.89-5.31C2.24,5.39,6.28,1.5,11.17,1.59c4.89-.09,8.93,3.8,9.02,8.69,0,1.97-.69,3.87-1.94,5.38Z"
        />
      </g>
    </SvgIcon>
  );
}
